import CloseOutlinedIcon from '@uala/icons/CloseOutlinedIcon';
import React from 'react';
import { createPortal } from 'react-dom';

import { useDelayUnmount } from '../utils/hooks';
import useKeyboard from '../utils/hooks/useKeyboard';
import { ComponentProps } from '../utils/types';
import {
  Backdrop,
  ModalCloseButton,
  ModalTitle,
  StyledModal,
  StyledModalContainer
} from './styles';
import ModalPropsInterface from './types';

const Modal: React.FC<ModalPropsInterface> = ({
  open,
  children,
  onClose,
  title,
  disableBackdropClick,
  hideCloseButton,
  fullWidth,
  ...props
}) => {
  const shouldRender = useDelayUnmount(open, 255);

  useKeyboard(['Escape'], onClose);

  if (!shouldRender) {
    return null;
  }

  return createPortal(
    <>
      <StyledModalContainer>
        <Backdrop
          data-testid="modal-backdrop"
          open={open}
          onClick={!disableBackdropClick ? onClose : undefined}
        />
        <StyledModal
          role="dialog"
          aria-labelledby={title ? 'modal-title' : ''}
          open={open}
          fullWidth={fullWidth}
          {...props}
        >
          {title && <ModalTitle id="modal-title">{title}</ModalTitle>}
          {!hideCloseButton && (
            <ModalCloseButton
              id="modal-close-button"
              size="icon"
              variant="unfilled"
              onClick={onClose}
              aria-label="Cerrar"
            >
              <CloseOutlinedIcon fontSize={24} />
            </ModalCloseButton>
          )}
          {children}
        </StyledModal>
      </StyledModalContainer>
    </>,
    document.body
  );
};

export type ModalProps = ComponentProps<typeof Modal>;
export default Modal;
